export const helvetiker = 'helvetiker' as const
export const helvetikerBold = 'helvetikerBold' as const
export const helvetikerRegular = 'helvetikerRegular' as const
export const robotoLight = 'robotoLight' as const
export const robotoMedium = 'robotoMedium' as const

export type FontName =
  | typeof helvetiker
  | typeof robotoLight
  | typeof robotoMedium
  | typeof helvetikerBold
  | typeof helvetikerRegular
export const fontNames = [helvetiker, helvetikerRegular, helvetikerBold, robotoLight, robotoMedium]


const bold = 'bold' as const 
const normal = 'normal' as const 
const lighter = 'lighter' as const

export const fontPaths: { [P in FontName]: string } = {
  helvetikerRegular: '/fonts/helvetiker_regular.json',
  helvetiker: '/fonts/helvetiker.json',
  helvetikerBold: '/fonts/helvetiker_bold.json',
  robotoLight: '/fonts/roboto_light.json',
  robotoMedium: '/fonts/roboto_medium.json'
}
